module.exports = __webpack_public_path__ + "static/media/governance-risk-compliance-grc.81b9e931.webp";